export const isEmojiString = (str: string) => !/[a-zA-Z0-9äöüÄÖÜß!@#$%^&*(),.?":{}|<>]/.test(str);
